module.exports = __webpack_public_path__ + "static/media/RP-20.27bab1ea.pdf";